<template>
	<!-- Open the modal using ID.showModal() method -->
	<dialog
		id="loadingModal"
		class="modal">
		<div class="modal-box w-fit bg-loader-bg border-loader-border border-2 m-4">
			<CommonLoader />
		</div>
	</dialog>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import { HIDE_API_LOADING, SHOW_API_LOADING } from "assets/events/api"

	const runtimeConfig = useRuntimeConfig()
	const { $eventBus } = useNuxtApp()

	const openModal = () => {
		const dialog = document.getElementById("loadingModal")
		if (dialog && !dialog.open) {
			dialog.showModal && dialog.showModal()
		}
	}

	const closeModal = () => {
		const dialog = document.getElementById("loadingModal")
		if (dialog && dialog.open) {
			dialog.close && dialog.close()
		}
	}

	onMounted(() => {
		$eventBus.$on(SHOW_API_LOADING, () => {
			openModal()
		})

		$eventBus.$on(HIDE_API_LOADING, () => {
			closeModal()
		})
	})

	onUnmounted(() => {
		$eventBus.$off(HIDE_API_LOADING)
		$eventBus.$off(SHOW_API_LOADING)
	})
</script>
